import { render, staticRenderFns } from "./FooterSection.vue?vue&type=template&id=fe695630&scoped=true&"
var script = {}
import style0 from "./FooterSection.vue?vue&type=style&index=0&id=fe695630&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe695630",
  null
  
)

export default component.exports